var map = {
	"./af/common.json": "fbf5",
	"./af/login.json": "526d",
	"./af/menu.json": "c8fb",
	"./af/register.json": "313e",
	"./af/welcome.json": "e870",
	"./en/common.json": "1e1c",
	"./en/login.json": "0149",
	"./en/menu.json": "350a7",
	"./en/register.json": "29cc",
	"./en/welcome.json": "c834"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";